// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var PageUITitle = require("../../../components/PageTitle/PageUITitle.bs.js");
var ProfilePageRelay = require("../../../v5/settings/ProfilePageRelay.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var MarkupHelpers = require("components/MarkupHelpers");

function ProfilePage(props) {
  return JsxRuntime.jsxs(MarkupHelpers.ContentBox, {
              paddingFull: true,
              hasShadow: true,
              children: [
                JsxRuntime.jsx(PageUITitle.make, {
                      title: "TAN Profile"
                    }),
                JsxRuntime.jsx(ProfilePageRelay.make, {})
              ]
            });
}

var make = ProfilePage;

exports.make = make;
/* PageUITitle Not a pure module */
